import React from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'
import { withStyles } from '@material-ui/core/styles'
import { withTranslation } from 'react-i18next'
import Drawer from '@material-ui/core/Drawer'
import AppBar from '@material-ui/core/AppBar'
import Toolbar from '@material-ui/core/Toolbar'
import List from '@material-ui/core/List'
import CssBaseline from '@material-ui/core/CssBaseline'
import Typography from '@material-ui/core/Typography'
import Divider from '@material-ui/core/Divider'
import IconButton from '@material-ui/core/IconButton'
import ListItem from '@material-ui/core/ListItem'
import ListItemText from '@material-ui/core/ListItemText'
import Collapse from '@material-ui/core/Collapse'
import MenuItem from '@material-ui/core/MenuItem'
import Menu from '@material-ui/core/Menu'
import ListItemIcon from '@material-ui/core/ListItemIcon'
import LanguageIcon from '@material-ui/icons/LanguageRounded'
import AccountCircle from '@material-ui/icons/AccountCircleRounded'
import AccountBox from '@material-ui/icons/AccountBoxTwoTone'
import ExpandLess from '@material-ui/icons/ExpandLessTwoTone'
import ExpandMore from '@material-ui/icons/ExpandMoreTwoTone'
import MailIcon from '@material-ui/icons/MailTwoTone'
import MailOutlineIcon from '@material-ui/icons/MailOutlineTwoTone'
import ChevronLeftIcon from '@material-ui/icons/ChevronLeftTwoTone'
import ChevronRightIcon from '@material-ui/icons/ChevronRightTwoTone'
import MenuIcon from '@material-ui/icons/MenuTwoTone'
import MoreIcon from '@material-ui/icons/MoreVertTwoTone'
import CalendarIcon from '@material-ui/icons/CalendarTodayTwoTone'
import PersonIcon from '@material-ui/icons/PersonTwoTone'
import HighlightIcon from '@material-ui/icons/HighlightTwoTone'
import LocalLibraryIcon from '@material-ui/icons/LocalLibraryTwoTone'
import GroupIcon from '@material-ui/icons/GroupTwoTone'
import TvIcon from '@material-ui/icons/TvTwoTone'
import DescriptionIcon from '@material-ui/icons/DescriptionTwoTone'
import ClassIcon from '@material-ui/icons/ClassTwoTone'
import SubjectIcon from '@material-ui/icons/SubjectTwoTone'
import TrendingUpIcon from '@material-ui/icons/TrendingUpRounded'
import NotificationTwoToneIcon from '@material-ui/icons/NotificationsTwoTone'
import ViewAgendaIcon from '@material-ui/icons/ViewAgendaTwoTone'
import FolderSpecialIcon from '@material-ui/icons/FolderSpecialTwoTone'
import GridOnIcon from '@material-ui/icons/GridOnTwoTone'
import DashboardIcon from '@material-ui/icons/DashboardTwoTone'
import PaymentIcon from '@material-ui/icons/PaymentTwoTone'
import ScheduleIcon from '@material-ui/icons/ScheduleTwoTone'
import AccessibilityNewIcon from '@material-ui/icons/AccessibilityNewTwoTone'
import ChatIcon from '@material-ui/icons/ChatTwoTone'
import SupervisedUserIcon from '@material-ui/icons/SupervisedUserCircleOutlined'
import FaceIcon from '@material-ui/icons/FaceTwoTone'
import AddCircleIcon from '@material-ui/icons/AddCircleTwoTone'
import AccountBalanceWalletIcon from '@material-ui/icons/AccountBalanceWalletTwoTone'
import AssignmentIcon from '@material-ui/icons/AssignmentTwoTone'
import ChromeReaderModeIcon from '@material-ui/icons/ChromeReaderModeTwoTone'
import Form from '../../components/Form'

import WithMaterialUI from '../../components/WithMaterialUI'

const drawerWidth = 260

const styles = (theme) => {
  return {
    root: {
      display: 'flex',
    },
    appBar: {
      zIndex: theme.zIndex.drawer + 1,
      transition: theme.transitions.create(['width', 'margin'], {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.leavingScreen,
      }),
    },
    appBarShift: {
      marginLeft: `${drawerWidth}px`,
      width: `calc(100% - ${drawerWidth}px)`,
      transition: theme.transitions.create(['width', 'margin'], {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.enteringScreen,
      }),
    },
    nested: {
      paddingLeft: `${theme.spacing.unit * 7}px`,
      paddingTop: '12px',
      paddingBottom: '12px',
    },
    menuButton: {
      paddingLeft: '16px',
      paddingRight: '16px',
      margin: '4px',
    },
    menuTitle: {
      paddingLeft: '24px',
    },
    menuItems: {
      position: 'absolute',
      right: '3%',
    },
    menuItemPadding: {
      paddingLeft: '12px',
      paddingRight: '12px',
    },
    multiListRootPadding: {
      paddingTop: '8px',
      paddingBottom: '8px',
    },
    multiButtonBaseRootPadding: {
      paddingLeft: '16px',
      paddingRight: '16px',
    },
    multiButtonBasePadding: {
      paddingTop: '12px',
      paddingBottom: '12px',
      paddingRight: '12px',
    },
    sideBarFont: {
      fontSize: '0.875em',
    },
    sidebarTextPadding: {
      paddingLeft: '8px',
    },
    svgIcon: {
      fontSize: '24px',
    },
    hide: {
      display: 'none',
    },
    drawer: {
      width: `${drawerWidth}px`,
      flexShrink: 0,
      whiteSpace: 'nowrap',
    },
    drawerOpen: {
      width: `${drawerWidth}px`,
      transition: theme.transitions.create('width', {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.enteringScreen,
      }),
    },
    drawerClose: {
      transition: theme.transitions.create('width', {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.leavingScreen,
      }),
      overflowX: 'hidden',
      width: `${theme.spacing.unit * 8 + 1}px`,
      // [theme.breakpoints.up('sm')]: {
      //   width: `${theme.spacing.unit * 9 + 1}px`,
      // },
    },
    toolbarRoot: {
      minHeight: '56px',
      backgroundColor: 'cornflowerblue',
    },
    toolbar: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'flex-end',
      padding: '0px 8px',
      minHeight: '56px',
    },
    content: {
      flexGrow: 1,
      padding: `${theme.spacing.unit * 3}px`,
    },
    listItemIcon: {
      marginRight: '16px',
    },
    listItem: {
      paddingLeft: '20px',
      paddingRight: '16px',
      paddingTop: '12px',
      paddingBottom: '12px',
      '&:focus': {
        backgroundColor: theme.palette.action.hover,
        borderLeft: '5px solid cornflowerblue',
      },
    },
    dividerHeight: {
      height: '1px',
    },
    collapseList: {
      backgroundColor: 'rgba(0,0,0,0.08)',
    },
    sectionDesktop: {
      display: 'none',
      [theme.breakpoints.up('md')]: {
        display: 'flex',
      },
    },
    sectionMobile: {
      display: 'flex',
      [theme.breakpoints.up('md')]: {
        display: 'none',
      },
    },
    dot: {
      height: '8px',
      width: '8px',
      backgroundColor: 'cornflowerblue',
      borderRadius: '50%',
      display: 'inline-block',
      position: 'absolute',
      top: '50%',
      transform: 'translate(40px, -50%)',
      visibility: 'hidden',
    },
  }
}

@withTranslation()
@WithMaterialUI
@withStyles(styles, { withTheme: true })
class DrawerPage extends React.Component {
  state = {
    open: false,
    anchorEl: null,
    mobileMoreAnchorEl: null,
    nestOpen: [],
  }

  getSideBarItems() {
    const { classes, t } = this.props
    return [
      {
        text: t('cms_agenda'),
        icon: <ViewAgendaIcon className={classes.svgIcon} />,
        subItems: [
          {
            text: t('cms_school_calender'),
            icon: <CalendarIcon className={classes.svgIcon} />,
            subItems: [],
          },
          {
            text: t('cms_timetable'),
            icon: <GridOnIcon className={classes.svgIcon} />,
            subItems: [],
          },
        ],
      },
      {
        text: t('cms_user_list'),
        icon: <PersonIcon className={classes.svgIcon} />,
        subItems: [
          {
            text: t('cms_user_list_class'),
            icon: <ClassIcon className={classes.svgIcon} />,
            subItems: [],
          },
          {
            text: t('cms_user_list_group'),
            icon: <GroupIcon className={classes.svgIcon} />,
            subItems: [],
          },
          {
            text: t('cms_user_list_chat_group'),
            icon: <ChatIcon className={classes.svgIcon} />,
            subItems: [],
          },
          {
            text: t('cms_user_list_student'),
            icon: <AccessibilityNewIcon className={classes.svgIcon} />,
            subItems: [],
          },
          {
            text: t('cms_user_list_parent'),
            icon: <FaceIcon className={classes.svgIcon} />,
            subItems: [],
          },
          {
            text: t('cms_user_list_teacher'),
            icon: <AccountBox className={classes.svgIcon} />,
            subItems: [],
          },
          {
            text: t('cms_user_list_admin'),
            icon: <SupervisedUserIcon className={classes.svgIcon} />,
            subItems: [],
          },
        ],
      },
      {
        text: t('cms_management'),
        icon: <DashboardIcon className={classes.svgIcon} />,
        subItems: [
          {
            text: t('cms_class_management'),
            icon: <ClassIcon className={classes.svgIcon} />,
            subItems: [],
          },
          {
            text: t('cms_group_management'),
            icon: <GroupIcon className={classes.svgIcon} />,
            subItems: [],
          },
          {
            text: t('cms_subject_management'),
            icon: <SubjectIcon className={classes.svgIcon} />,
            subItems: [],
          },
        ],
      },
      {
        text: t('cms_attendance_system'),
        icon: <ScheduleIcon className={classes.svgIcon} />,
        subItems: [],
      },
      {
        text: t('cms_reply_slip'),
        icon: <MailIcon className={classes.svgIcon} />,
        subItems: [],
      },
      {
        text: t('cms_payment_system'),
        icon: <PaymentIcon className={classes.svgIcon} />,
        subItems: [
          {
            text: t('cms_payment_system_add_value'),
            icon: <AddCircleIcon className={classes.svgIcon} />,
            subItems: [],
          },
          {
            text: t('cms_payment_system_add_value_record'),
            icon: <AssignmentIcon className={classes.svgIcon} />,
            subItems: [],
          },
          {
            text: t('cms_payment_system_payment_record'),
            icon: <ChromeReaderModeIcon className={classes.svgIcon} />,
            subItems: [],
          },
          {
            text: t('cms_payment_system_reply_slip_management'),
            icon: <MailOutlineIcon className={classes.svgIcon} />,
            subItems: [],
          },
          {
            text: t('cms_payment_system_account_management'),
            icon: <AccountBalanceWalletIcon className={classes.svgIcon} />,
            subItems: [],
          },
        ],
      },
      {
        text: t('cms_daily_verse'),
        icon: <HighlightIcon className={classes.svgIcon} />,
        subItems: [],
      },
      {
        text: t('cms_school_news'),
        icon: <NotificationTwoToneIcon className={classes.svgIcon} />,
        subItems: [],
      },
      {
        text: t('cms_library'),
        icon: <LocalLibraryIcon className={classes.svgIcon} />,
        subItems: [],
      },
      {
        text: t('cms_school_tv'),
        icon: <TvIcon className={classes.svgIcon} />,
        subItems: [],
      },
      {
        text: t('cms_promotion'),
        icon: <TrendingUpIcon className={classes.svgIcon} />,
        subItems: [],
      },
      {
        text: t('cms_mobile_theme'),
        icon: <FolderSpecialIcon className={classes.svgIcon} />,
        subItems: [],
      },
      {
        text: t('cms_description'),
        icon: <DescriptionIcon className={classes.svgIcon} />,
        subItems: [],
      },
    ]
  }

  handleClick = (index) => {
    const nestOpenCopy = JSON.parse(JSON.stringify(this.state.nestOpen))
    nestOpenCopy[index] = !nestOpenCopy[index]
    this.setState(() => {
      return { nestOpen: nestOpenCopy }
    })
  }

  handleLanguageMenuOpen = (event) => {
    this.setState({ anchorEl: event.currentTarget })
  }

  handleMenuClose = () => {
    this.setState({ anchorEl: null })
    this.handleMobileMenuClose()
  }

  handleMobileMenuOpen = (event) => {
    this.setState({ mobileMoreAnchorEl: event.currentTarget })
  }

  handleMobileMenuClose = () => {
    this.setState({ mobileMoreAnchorEl: null })
  }

  handleDrawerOpen = () => {
    this.setState({ open: true })
  }

  handleDrawerClose = () => {
    const nestOpenCopy = JSON.parse(JSON.stringify(this.state.nestOpen))
    for (let i = 0; i < nestOpenCopy.length; i += 1) {
      nestOpenCopy[i] = false
    }
    this.setState(() => {
      return { nestOpen: nestOpenCopy }
    })
    this.setState({ open: false })
  }

  render() {
    const { anchorEl, mobileMoreAnchorEl } = this.state
    const {
      classes, theme, i18n, t,
    } = this.props
    const isMenuOpen = Boolean(anchorEl)
    const isMobileMenuOpen = Boolean(mobileMoreAnchorEl)
    const renderMenu = (
      <Menu
        anchorEl={anchorEl}
        anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
        transformOrigin={{ vertical: 'top', horizontal: 'right' }}
        open={isMenuOpen}
        onClose={this.handleMenuClose}
      >
        <MenuItem onClick={this.handleMenuClose} className={classes.multiButtonBaseRootPadding}>
          <button
            onClick={() => {
              return i18n.changeLanguage(t('translation_eng'))
            }}
          >
            {t('lang_eng')}
          </button>
        </MenuItem>
        <MenuItem onClick={this.handleMenuClose} className={classes.multiButtonBaseRootPadding}>
          <button
            onClick={() => {
              return i18n.changeLanguage(t('translation_zhHant'))
            }}
          >
            {t('lang_zhHant')}
          </button>
        </MenuItem>
      </Menu>
    )
    const renderMobileMenu = (
      <Menu
        anchorEl={mobileMoreAnchorEl}
        anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
        transformOrigin={{ vertical: 'top', horizontal: 'right' }}
        open={isMobileMenuOpen}
        onClose={this.handleMenuClose}
      >
        <div className={classes.multiListRootPadding}>
          <MenuItem className={classes.multiButtonBaseRootPadding}>
            <IconButton color="inherit" className={classes.multiButtonBasePadding}>
              <AccountCircle className={classes.svgIcon} />
            </IconButton>
            <p>Profile</p>
          </MenuItem>
          <MenuItem
            onClick={this.handleLanguageMenuOpen}
            className={classes.multiButtonBaseRootPadding}
          >
            <IconButton color="inherit" className={classes.multiButtonBasePadding}>
              <LanguageIcon className={classes.svgIcon} />
            </IconButton>
            <p>Language</p>
          </MenuItem>
        </div>
      </Menu>
    )

    return (
      <div className={classes.root}>
        <CssBaseline />
        <AppBar
          position="fixed"
          className={classNames(classes.appBar, {
            [classes.appBarShift]: this.state.open,
          })}
        >
          <Toolbar disableGutters={!this.state.open} className={classes.toolbarRoot}>
            <IconButton
              color="inherit"
              aria-label="Open drawer"
              onClick={this.handleDrawerOpen}
              className={classNames(classes.menuButton, {
                [classes.hide]: this.state.open,
              })}
            >
              <MenuIcon />
            </IconButton>
            <Typography variant="h6" color="inherit" className={classes.menuTitle} noWrap>
              {t('cms')}
            </Typography>
            <div className={classes.grow} />
            <div className={classes.menuItems}>
              <div className={classes.sectionDesktop}>
                <IconButton
                  aria-owns={isMenuOpen ? 'material-appbar' : undefined}
                  aria-haspopup="true"
                  onClick={this.handleLanguageMenuOpen}
                  color="inherit"
                  className={classes.menuItemPadding}
                >
                  <LanguageIcon />
                </IconButton>
                <IconButton
                  aria-owns={isMenuOpen ? 'material-appbar' : undefined}
                  aria-haspopup="true"
                  color="inherit"
                  className={classes.menuItemPadding}
                >
                  <AccountCircle />
                </IconButton>
              </div>
              <div className={classes.sectionMobile}>
                <IconButton
                  aria-haspopup="true"
                  onClick={this.handleMobileMenuOpen}
                  color="inherit"
                >
                  <MoreIcon />
                </IconButton>
              </div>
            </div>
          </Toolbar>
        </AppBar>
        {renderMenu}
        {renderMobileMenu}
        <Drawer
          variant="permanent"
          className={classNames(classes.drawer, {
            [classes.drawerOpen]: this.state.open,
            [classes.drawerClose]: !this.state.open,
          })}
          classes={{
            paper: classNames({
              [classes.drawerOpen]: this.state.open,
              [classes.drawerClose]: !this.state.open,
            }),
          }}
          open={this.state.open}
        >
          <div className={classes.toolbar}>
            SPC
            <IconButton onClick={this.handleDrawerClose}>
              {theme.direction === 'rtl' ? <ChevronRightIcon /> : <ChevronLeftIcon />}
            </IconButton>
          </div>
          <List>
            {this.getSideBarItems().map((obj, index) => {
              return obj.subItems.length === 0 ? (
                <ListItem button key={obj.text} className={classes.listItem}>
                  <ListItemIcon className={classes.listItemIcon}>{obj.icon}</ListItemIcon>
                  <ListItemText
                    primary={obj.text}
                    classes={{ primary: classes.sideBarFont }}
                    className={classes.sidebarTextPadding}
                  />
                </ListItem>
              ) : (
                [
                  <ListItem
                    button
                    key={obj.text}
                    className={classes.listItem}
                    onClick={() => {
                      return this.handleClick(index)
                    }}
                  >
                    <ListItemIcon className={classes.listItemIcon}>{obj.icon}</ListItemIcon>
                    <ListItemText
                      primary={obj.text}
                      classes={{ primary: classes.sideBarFont }}
                      className={classes.sidebarTextPadding}
                    />
                    {this.state.nestOpen[index] ? <ExpandLess /> : <ExpandMore />}
                  </ListItem>,
                  obj.subItems.map((obj1) => {
                    return (
                      <Collapse
                        key={obj1.text}
                        in={this.state.nestOpen[index]}
                        timeout="auto"
                        unmountOnExit
                        className={classes.collapseList}
                      >
                        <List component="div" disablePadding>
                          <div className={classes.dot} id={`${obj1.text} dot`} />
                          <ListItem button className={classes.nested} key={obj1.text}>
                            <ListItemIcon className={classes.listItemIcon}>
                              {obj1.icon}
                            </ListItemIcon>
                            <ListItemText
                              primary={obj1.text}
                              classes={{ primary: classes.sideBarFont }}
                              className={classes.sidebarTextPadding}
                            />
                          </ListItem>
                        </List>
                      </Collapse>
                    )
                  }),
                ]
              )
            })}
          </List>
          <Divider className={classes.dividerHeight} />
        </Drawer>
        <main className={classes.content}>
          <div className={classes.toolbar} />
          <Form />
        </main>
      </div>
    )
  }
}

DrawerPage.propTypes = {
  classes: PropTypes.object,
  theme: PropTypes.object,
  i18n: PropTypes.object,
  t: PropTypes.func,
}

export default DrawerPage
